module.exports = __webpack_public_path__ + "static/gallery05-894f37fd82e8f1a00743232861fab791.jpg";